import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import PercentageFigure from '../../PercentageFigure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'g',
  title: 'Price Change Percent (60 Day)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '60d';
  }

  get overlayText() {
    return 'Price Change % in last 60 days';
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <PercentageFigure amount={props.row.priceChange60d} />
    </td>
  );
}


class PriceChange60d extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.priceChange60d < b.priceChange60d) {
      return -1;
    }
    if (a.priceChange60d > b.priceChange60d) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange60d < b.priceChange60d) {
      return 1;
    }
    if (a.priceChange60d > b.priceChange60d) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PriceChange60d;

